import { render } from "./LoadingPanel.vue?vue&type=template&id=081d95db"
import script from "./LoadingPanel.vue?vue&type=script&lang=js"
export * from "./LoadingPanel.vue?vue&type=script&lang=js"

import "./LoadingPanel.vue?vue&type=style&index=0&id=081d95db&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__